import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table-responsive mt-5" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, " File "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px text-end" }, " Created at ")
  ])
], -1)
const _hoisted_4 = { class: "fw-bolder fs-6 text-gray-800" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "fw-bolder fs-6 text-gray-800 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (entity) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: entity.file_name
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  href: entity.url
                }, _toDisplayString(entity.file_name), 9, _hoisted_5)
              ])
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(entity.created_at), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}